import React, { useEffect } from 'react'
import 'LIBRARY/HeaderWorkspace/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
const imageExtensions = ['jpeg', 'jpg', 'png'];

const UserProfile = ({userSignOut}) => {

  // useEffect(() => {
  //    console.log(userSignOut);
  // }, [])

  const signOut = ()=>{
      localStorage.setItem("logout-event", Date.now());
    window.location.href=`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`;
    userSignOut(0);
  }
  return (
    <div className='subContainers workspace-current-modal-mode' style={{padding: "0px 0px 20px 0px"}}>
      <div style={{ display: "flex",alignItems:'center', justifyContent: "space-between", padding: "12px", gap: "20px" }}>
        <div style={{ width: "25%" }}>
          {
            imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
            <img src={config.userPic} style={{width:'100%', height:'60px',width:'60px', borderRadius: "100%", border: "1px solid #dfdfdf" }} />
            :
              <FontAwesomeIcon
                  icon={['fas', 'user-circle']}
                  size="lg"
                  className='ws-lock-subscription-color'
                  style={{width:'100%', height:'60px',width:'60px', borderRadius: "100%", border: "1px solid #dfdfdf" }}
              />
          }
        </div>
        <div className='py-2' style={{ width: "75%" }}>
          <p style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "0px"}}>
            {config.instructorInfo.FirstName} {config.instructorInfo.LastName}
          </p>
          <p style={{ fontSize: "12px", marginBottom: "0px"}} title={config.emailId}>
            {config.emailId}
          </p>
          <p style={{ fontSize: "12px", marginBottom: "0px"}}>
            USER ID: <span style={{ fontWeight:"bold"}}>{config.instructorInfo.user_id}</span>
          </p>
        </div>
      </div>

      <div id='buttonDiv' style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
        <button className='accButtons' onClick={()=>window.location.href=`${config.RootUrl}/modules/personalise/#/`}>
          My Account
        </button>
        <button className='signoutBtn' onClick={()=>signOut()}>
          Sign out
        </button>
      </div>
    </div>
  )
}

export default UserProfile